export default __webpack_public_path__ + "static/media/scrum-master.51a5b2da.jpg";